'use client';

import AppRecoverModalHost from '@/components/AppRecoverModalHost';
import { isAppClient } from '@/lib/LocalStorage';
import { Suspense, useEffect, useState } from 'react';
import AndroidBridge from '@/app/AndroidBridge';
import NativeLinkInterceptor from '@/app/NativeLinkInterceptor';
import NativeRouteBridge from '@/app/NativeRouteBridge';

function cookieOsType(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie.match(/(?:^|; )hzc_os_type=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : undefined;
}

/**
 * Native webview chrome that used to branch in the root layout via cookies().
 * cookies() in layout dynamizes every RSC flight and kills catalog prefetch.
 */
export default function NativeAppChrome() {
  const [isApp, setIsApp] = useState(false);
  const [osType, setOsType] = useState<string | undefined>();

  useEffect(() => {
    const sync = () => {
      setIsApp(isAppClient());
      setOsType(cookieOsType());
    };
    sync();
    window.addEventListener('platform:set', sync);
    return () => window.removeEventListener('platform:set', sync);
  }, []);

  if (!isApp) return null;

  return (
    <>
      <AppRecoverModalHost />
      <Suspense fallback={null}>
        <NativeRouteBridge />
      </Suspense>
      {osType === 'ios' ? <NativeLinkInterceptor /> : null}
      <AndroidBridge />
    </>
  );
}
